import React, { useState, useEffect } from 'react';
import { BarChart3, AlertCircle } from 'lucide-react';
import Layout from '../components/Layout';
import Loading from '../components/Loading';
import { analysisService } from '../services/api';

const AIAnalysisPage = () => {
  const [analysisData, setAnalysisData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadAnalysisData = async () => {
      try {
        const response = await analysisService.getAIAnalysis();
        setAnalysisData(response.data);
      } catch (error) {
        console.error('AI Analysis load error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadAnalysisData();
  }, []);

  if (isLoading) {
    return (
      <Layout>
        <Loading message="AI 분석 데이터를 불러오는 중..." />
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">📊 AI 분석</h1>
          <p className="text-gray-600">상세한 AI 분석 결과를 확인하세요</p>
        </div>

        {/* 분석 결과 */}
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center space-x-3 mb-4">
            <BarChart3 className="w-6 h-6 text-blue-500" />
            <h2 className="text-lg font-semibold text-gray-900">분석 결과</h2>
          </div>
          
          {analysisData ? (
            <div className="space-y-4">
              {/* 여기에 분석 데이터 표시 */}
              <p className="text-gray-600">분석 데이터가 표시됩니다.</p>
            </div>
          ) : (
            <div className="text-center py-12">
              <BarChart3 className="w-12 h-12 text-gray-400 mx-auto mb-3" />
              <p className="text-gray-500">분석 데이터가 없습니다.</p>
            </div>
          )}
        </div>

        {/* 안내 메시지 */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <AlertCircle className="w-5 h-5 text-blue-600" />
            <p className="text-blue-800">
              AI 분석 기능이 개발 중입니다. 종합 AI 대시보드에서 더 자세한 분석을 확인할 수 있습니다.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AIAnalysisPage;